import React, {useState, useRef, useEffect} from 'react';
import './InputAddImage.css'; // Стили по БЭМ
import {ReactComponent as UploadIcon} from '../../images/upload.svg';
import {createOrganizationImage, removeImage} from '../../api/orgsApi';

const InputAddImage = ({handleChange, fileInputRef, imageValue}) => {
  const [image, setImage] = useState(imageValue); // Состояние для хранения изображения
  const [isLoading, setIsLoading] = useState(false); // Состояние загрузки
  const [error, setError] = useState(null); // Ошибка

  const [isDragOver, setIsDragOver] = useState(false); // Состояние для Drag & Drop
  const dragCounter = useRef(0); // Счетчик drag-событий

  // Обработчик выбора файла
  const handleFileChange = async (file) => {
    if (!file) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await createOrganizationImage(file);
      handleChange({target: {name: 'image', value: response.data.image}});
    } catch (err) {
      setError('Ошибка загрузки');
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Обработчик клика по области для выбора файла
  const handleClick = () => {
    fileInputRef.current.click();
  };
  // Обработчики Drag & Drop с фиксами
  const handleDragEnter = (event) => {
    event.preventDefault();
    dragCounter.current += 1; // Увеличиваем счетчик входа
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    dragCounter.current -= 1; // Уменьшаем счетчик выхода
    if (dragCounter.current === 0) {
      setIsDragOver(false);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    dragCounter.current = 0; // Сбрасываем счетчик
    setIsDragOver(false);

    const file = event.dataTransfer.files[0];
    handleFileChange(file);
  };
  useEffect(() => {
    setImage(imageValue); // Обновляем изображение при изменении пропсов
  }, [imageValue]);

  const handleRemoveImage = (e) => {
    e.stopPropagation();
    removeImage(image)
      .then(() => console.log('Изображение удалено'))
      .catch((err) => console.log('Ошибка удаления', err));

    setImage(null);
    handleChange({target: {name: 'image', value: ''}}); // Очищаем formData
    fileInputRef.current.value = '';
  };

  return (
    <div
      className={`input-add-image__dropzone ${
        image ? 'input-add-image__dropzone--has-image' : ''
      } ${isDragOver ? 'input-add-image__dropzone--drag-over' : ''}`}
      onClick={handleClick}
      onDragEnter={handleDragEnter}
      onDragOver={(e) => e.preventDefault()}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {image ? (
        <>
          <img src={image} alt='Превью' className='input-add-image__preview' />
          <button
            onClick={handleRemoveImage}
            className='input-add-image__delete-btn'
          />
        </>
      ) : (
        <div className='input-add-image__overlay'>
          <span className='input-add-image__icon'>
            <UploadIcon />
          </span>
          <span className='input-add-image__text'>
            {isDragOver ? 'Отпустите файл здесь' : 'Добавить изображение'}
          </span>
        </div>
      )}
      {isLoading && (
        <div className='input-add-image__loader'>
          <div className='input-add-image__loader-spinner'></div>
        </div>
      )}
      <input
        type='file'
        ref={fileInputRef}
        className='input-add-image__file-input'
        onChange={(e) => handleFileChange(e.target.files[0])}
        accept='image/*'
      />
      {error && <div className='input-add-image__error'>{error}</div>}
    </div>
  );
};

export default InputAddImage;
